<!-- 历史申报 -->
<template>
  <div class="historicalView">
    <div class="appeal-table">
      <el-table
        :data="list"
        size="medium"
        stripe
        style="width: 100%"
        :highlight-current-row="true"
      >
        <el-table-column
          prop="xzxdrmc"
          align="center"
          label="企业名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="xzxdrdm"
          label="统一社会信用代码"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="jljb"
          label="奖章等级"
          width="80"
          :formatter="formatterJljb"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="jlsyrq"
          label="奖励日期"
          width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="yxjzq"
          label="过期日期"
          width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="rdwsh"
          label="文书号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="examine"
          label="审核状态"
          width="100"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.examine == 0" style="color: #f90">审核中</p>
            <p v-if="scope.row.examine == 1" style="color: #61bf43">审核成功</p>
            <p v-if="scope.row.examine == 2" style="color: #f10">审核失败</p>
          </template>
        </el-table-column>
      </el-table>
      <empty v-if="!list.length" />
    </div>
  </div>
</template>

<script>
import { getHistory } from "@/api";

export default {
  data() {
    return {
      gradeArr: [
        "单位获得县级以上表彰或奖励",
        "单位获得市级以上表彰或奖励",
        "单位获得省级以上表彰或奖励",
        "单位主要负责人获得市（厅）级以上表彰或奖励",
        "企业获得市级工程质量安全奖项",
        "企业获得省级工程质量安全奖项",
        "企业获得国家级工程质量安全奖项",
        "企业获评泰安市级科技研发平台",
        "企业获评泰安省级科技研发平台",
        "企业获评泰安国家级科技研发平台",
        "企业获评泰安市级科技人才工程",
        "企业获评泰安省级科技人才工程",
        "企业获评泰安国家级科技人才工程",
      ],
      list: [],
    };
  },
  methods: {
    formatterJljb(row) {
      let jljb = row.jljb;
      console.log(jljb);
      return this.gradeArr[jljb];
    },
    getHistory() {
      getHistory().then((res) => {
        this.list = res;
      });
    },
  },
  mounted() {
    this.getHistory();
  },
  created() {
    this.$emit("userEmit", this.$route.path);
  },
};
</script>

<style scoped lang="scss">
.historicalView {
  width: 100%;
  height: auto;

  .appeal-table {
    & > .appeal-header {
      font-size: 17px;
      font-weight: 400;
      background: #f4f4f4;
      border: 1px solid #e7e8ea;
      border-top: 4px solid #e7e8ea;

      p {
        padding: 18px 0;
        flex-basis: 20%;
        text-align: center;

        &:first-of-type {
          flex-basis: 35%;
        }

        // &:nth-child(2) {
        // 	flex-basis: 35%;
        // }
      }
    }

    & > .appeal-body {
      font-size: 14px;

      &:nth-child(odd) {
        &:not(.appeal-content) {
          background-color: #fbfbfb;
        }
      }

      p {
        cursor: pointer;
        padding: 10px 5px;
        flex-basis: 20%;
        text-align: center;

        &:first-of-type {
          flex-basis: 35%;
          text-align: left;
        }

        &:last-of-type {
          color: #e25670;

          &:hover {
            text-decoration: underline;
          }
        }

        // &:nth-child(2) {
        // 	flex-basis: 35%;
        // }
      }
    }

    .appeal-content {
      flex-wrap: wrap;

      & > div {
        flex: 50%;
        text-align: left;
        font-size: 14px;
        padding: 10px 0 10px 10%;

        & > .content {
          color: #e25670;
        }
      }
    }
  }
}
</style>
